import styled from '@emotion/styled';
import { Button, Col, Form, Input, Row, notification } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import loginBG from '../../../../assets/images/im1.jpg';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { createUser } from '../../../../redux/userStore/actions';
import { UserStateType } from '../../../../redux/userStore/reducer';
import { ROUTES } from '../../../../routes';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { signIn, verify } from '../../../login/network';
import { checkProfile } from '../../../shared/ProtectedRoutes';

const Container = styled.div`
  background-image: url(${loginBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  > div {
    background:
      linear-gradient(90deg, rgba(4, 16, 24, 0.96), rgba(4, 16, 24, 0.84) 48%, rgba(20, 11, 10, 0.86)),
      radial-gradient(circle at 18% 20%, rgba(255, 79, 31, 0.16), transparent 28%);
    min-height: 560px;
    align-items: center;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 44px 6%;
    position: relative;
    overflow: hidden;

    &::before {
      background-image: url('/assets/images/moranje-logo.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
      height: min(72vw, 820px);
      opacity: 0.1;
      pointer-events: none;
      position: absolute;
      right: 37%;
      top: 50%;
      transform: translate(50%, -50%);
      width: min(72vw, 820px);
    }

    > * {
      position: relative;
      z-index: 1;
    }

    > .box {
      font-family: Poppins-R;
      padding: 18px !important;
    }

    > .box2 {
      width: 50%;
      font-family: Poppins-R;
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .hero-content {
    color: white;
    font-family: Poppins-R;
    max-width: 760px;
  }

  .hero-title {
    color: #f8fafc;
    font-family: Poppins-B;
    font-size: clamp(40px, 5vw, 68px);
    letter-spacing: 0;
    line-height: 1.02;
    margin: 0;
    max-width: 760px;
  }

  .hero-description {
    color: rgba(248, 250, 252, 0.78);
    font-size: 17px;
    line-height: 1.75;
    margin: 22px 0 26px;
    max-width: 620px;
  }

  .hero-brand {
    display: inline-block;
    font-family: Poppins-B;
    white-space: nowrap;
  }

  @media (max-width: 767px) {
    > div {
      min-height: auto;
      padding: 24px 18px 34px;
    }

    .hero-title {
      font-size: clamp(34px, 11vw, 48px);
    }

    .hero-description {
      font-size: 15px;
    }

    > div::before {
      height: 92vw;
      opacity: 0.08;
      right: 18%;
      top: 35%;
      width: 92vw;
    }
  }
`;

type LayoutType = Parameters<typeof Form>[0]['layout'];

const SignInContainer = styled.div`
  font-family: Poppins-R;
  width: 100%;

  .ant-form-item-explain.ant-form-item-explain-error {
    font-size: 11px;
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > div {
      background-color: white;
      width: 100%;
      max-width: 420px;
      min-height: 390px;
      box-shadow: 0 26px 70px rgba(0, 0, 0, 0.36);
      padding: 24px;
      border: 1px solid rgba(255, 255, 255, 0.72);
      border-radius: 18px;
    }
  }

  @media (min-width: 768px) {
    padding: 0px;
    > div {
      > div {
        width: 100%;
      }
    }
  }

  @media (max-width: 767px) {
    > div {
      > div {
        min-height: auto;
        padding: 20px 18px;
        border-radius: 16px;
      }
    }
  }
`;

export const Banner = () => {
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );
  const isConnected = connectedUser?.isConnected();
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const [isLoading, setIsLoading] = useState(false);
  const [isOtp, setisOTP] = useState(false);
  const [runningU, setRunningU] = useState<UserStateType | undefined>();
  const router = useHistory();
  const dispatch = useDispatch();

  const redirectToPage = () => {
    if (runningU) {
      dispatch(createUser(runningU));
      if (checkProfile(runningU.profils as any, 'admin')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'resp_commercial')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'commercial')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'responsable')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'chef_agence')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'gestionnaire')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'sadmin')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      }
    }
  };

  return (
    <Container>
      <Row gutter={[32, 24]}>
        <Col xs={24} xl={isConnected ? 24 : 15} md={isConnected ? 24 : 15}>
          <div className='hero-content'>
            <h1 className='hero-title'>
              Le terminal obligataire pour l'Afrique financière.
            </h1>
            <p className='hero-description'>
              Analysez les titres, suivez la profondeur de marché et exécutez
              vos opérations avec une plateforme conçue pour les exigences des
              desks de trading institutionnels.
            </p>
          </div>
        </Col>
        <Col
          xs={isConnected ? 0 : 24}
          sm={isConnected ? 0 : 24}
          md={isConnected ? 0 : 8}
          xl={isConnected ? 0 : 8}
          className={isConnected ? '' : 'box'}
        >
          <SignInContainer>
            <div>
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 18,
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'Poppins-B',
                      fontSize: 32,
                    }}
                  >
                    <span style={{ color: ORANGE }}>Moranj</span>
                    <span style={{ color: PRIMARY }}>E</span>
                    <span style={{ color: YELLOW }}>Trade</span>
                  </span>
                </div>
                <Form
                  layout={formLayout}
                  form={form}
                  labelCol={{ span: 20 }}
                  wrapperCol={{ span: 25 }}
                  onFinish={async (data) => {
                    if (runningU) {
                      const { code }: { code: string } = data;
                      // if (code === '1234') {
                      //   redirectToPage();
                      // } else {
                      //   notification.error({
                      //     message: 'Erreur',
                      //     description: 'Code incorrect',
                      //   });
                      // }
                      // return;
                      await verify(runningU.email, code)
                        .then(async ({ statusCode, data }) => {
                          if (data.ok) {
                            redirectToPage();
                            // Tu peux rediriger vers une autre page ici
                          } else {
                            setRunningU(undefined);
                            notification.error({
                              message: 'Erreur',
                              description: data.error,
                            });
                          }
                        })
                        .catch((err) => {
                          setRunningU(undefined);
                          notification.error({
                            message: 'Erreur',
                            description: err.message || err,
                          });
                          setIsLoading(false);
                        });
                    } else {
                      setIsLoading(true);
                      const { email, password } = data;
                      await signIn(email, password)
                        .then(
                          ({
                            statusCode,
                            data,
                          }: {
                            statusCode: any;
                            data: any;
                          }) => {
                            if (statusCode.toString()[0] === '2') {
                              console.log(data);
                              setRunningU({
                                authentifie: true,
                                id: data.id,
                                agence: data.agence,
                                url: data.url,
                                nom: data.nom,
                                prenom: data.prenom,
                                email: data.email,
                                profils: data.profils,
                                manager: data.manager,
                                partenaire: data.partenaire,
                                token: '',
                                nextAuthDate:
                                  new Date().getTime() + 12 * 60 * 60 * 1000,
                                achat: 0,
                                vente: 0,
                              });
                              setisOTP(true);
                            } else {
                              notification.error({
                                message: 'Erreur',
                                description: data.message,
                              });
                              setIsLoading(false);
                            }
                          },
                        )
                        .catch((err: Error) => {
                          notification.error({
                            message: 'Erreur',
                            description: err.message,
                          });
                          setIsLoading(false);
                        });
                    }
                  }}
                >
                  {isOtp ? (
                    <>
                      <Form.Item
                        label='OTP'
                        name='code'
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Le champ otp est requis',
                          },
                        ]}
                      >
                        <Input placeholder='Entrer le code otp reçu par SMS' />
                      </Form.Item>
                      <Form.Item>
                        <Button
                          type='primary'
                          htmlType='submit'
                          size='large'
                          style={{
                            width: '100%',
                            backgroundColor: ORANGE,
                            borderColor: PRIMARY,
                            borderWidth: 0,
                            marginBottom: 20,
                          }}
                        >
                        Vérifier
                        </Button>
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        label='Email'
                        name='email'
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            type: 'email',
                            message: 'Le champ email est requis',
                          },
                        ]}
                      >
                        <Input placeholder='adresse mail' type='email' />
                      </Form.Item>
                      <Form.Item
                        label='Mot de passe'
                        name='password'
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Le mot de passe est requis',
                          },
                        ]}
                      >
                        <Input.Password placeholder='mot de passe' />
                      </Form.Item>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          color: 'red',
                        }}
                      >
                        <p
                          style={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontSize: 12,
                          }}
                        >
                          Mot de passe oublié ?
                        </p>
                      </div>

                      <Form.Item>
                        <Button
                          type='primary'
                          htmlType='submit'
                          size='large'
                          loading={isLoading}
                          style={{
                            width: '100%',
                            backgroundColor: ORANGE,
                            borderColor: PRIMARY,
                            borderWidth: 0,
                            marginBottom: 20,
                          }}
                        >
                          Connecter
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form>
              </div>
            </div>
          </SignInContainer>
        </Col>
      </Row>
    </Container>
  );
};
